import React, { useMemo } from 'react';
import { getCodeMappingId, getCodetableId, getGroupedResult } from './get-code-data-id';
import { CodeMappingTileWrapper } from 'app/area/code-mappings/components/code-mapping-tile-wrapper';
import { CodeMappingsTile } from 'app/area/code-mappings/common/code-mappings-tile';
import { groupCodeMappings } from 'app/area/code-mappings/common/mappings';
import { CodeMappingItem } from 'app/area/code-mappings/components/code-mapping-item';
import { CodeMappingItemsProps } from 'app/area/code-mappings/components/types';
import { ElementLoader } from 'ui';

export const CodeMappingItems: React.FC<CodeMappingItemsProps> = ({
  id, importSetId, mappingsList, modifiedMappings, codetableIds, fetchingItemId, metadata,
  updatingExternalValue, codetableOptions, validation, codetableAccess, translation, loadMetadata, modifyItem,
  copyToAll, loadCodetableOptions, loadCodetablesAccess, loadCategoryOptions, loadItem
}) => {

  const codeMappings = useMemo(() => groupCodeMappings(mappingsList), [mappingsList]);

  return mappingsList && mappingsList.length > 0
    ? <CodeMappingsTile>
      {codetableIds.map((key, codetableIndex) => {

        const codetableId = getCodetableId(key);
        const displayCopyToAll = codeMappings[key]?.length > 1;

        return <CodeMappingTileWrapper
          key={key}
          id={id}
          codetableIndex={codetableIndex}
          importSetId={importSetId}
          codetableId={codetableId}
          description={getGroupedResult(key, codeMappings)}
          fetchingItemId={fetchingItemId}
          isLoaded={mappingsList.some(item => !!item.id && item.codetable.value === codetableId)}
          translation={translation}
          loadItem={loadItem}>
          {fetchingItemId === codetableId
            ? <ElementLoader />
            : codeMappings[key].map((data, codeMappingIndex) =>
              <CodeMappingItem
                key={getCodeMappingId(data)}
                index={codeMappingIndex}
                data={data}
                mappingsList={mappingsList}
                modifiedMappings={modifiedMappings}
                updatingExternalValue={updatingExternalValue}
                codetableAccess={codetableAccess}
                displayCopyToAll={displayCopyToAll}
                metadata={metadata}
                validation={validation}
                translation={translation}
                codetableOptions={codetableOptions}
                modifyItem={modifyItem}
                copyToAll={copyToAll}
                loadCodetableOptions={loadCodetableOptions}
                loadCategoryOptions={loadCategoryOptions}
                loadCodetablesAccess={loadCodetablesAccess}
                loadMetadata={loadMetadata}
              />)}
        </CodeMappingTileWrapper>;
      })}
    </CodeMappingsTile>
    : null;
};
